<template>
  <div class="mutil-select">
    <el-select
      v-model="getIds"
      multiple
      filterable
      remote
      size="small"
      reserve-keyword
      :placeholder="`请输入${title}`"
      :remote-method="remoteMethod"
      :loading="loading"
      :collapse-tags="true"
      @focus="handleFocus"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { queryDrugAgencyList } from "@/api/statistics";
import { getListByType } from "@/api/businessManage";
export default {
  name: "MutilSelect",
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
    //查询列表的条件 客户类型 ｜ 供应商 | 平台业务管理-订单状态
    type: {
      type: String,
      default: "", //supplier ｜ customer ｜ platformBusiness-orderStatus
    },
    title: {
      type: String,
      default: "",
    },
    typeList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    getIds: {
      set(val) {
        this.$emit("update:ids", val);
      },
      get() {
        return this.ids;
      },
    },
  },
  data() {
    return {
      options: [],
      list: [],
      loading: false,
    };
  },
  methods: {
    handleFocus() {
      if (this.type === "customer") {
        this.remoteMethod("");
      }
    },
    remoteMethod(query) {
      if (this.type === "supplier") {
        if (query !== "") {
          this.getSupplierList(query);
        }
      } else if (this.type === "customer") {
        this.getListByType(query);
      }
    },
    // 获取供应商列表
    getSupplierList(query) {
      queryDrugAgencyList({ size: 50, current: 1, shopName: query }).then(
        (res) => {
          const { records = [], total = 0 } = res.data || {};
          this.options = records.map((item) => {
            return { value: item.id, label: item.shopName };
          });
        }
      );
    },
    // 获取客户类型列表
    getListByType() {
      getListByType({
        type: 0, //0 客户类型  1商户类型
      }).then((res) => {
        const { data = [] } = res;
        this.options = data.map((item) => {
          return { value: item.typeCode, label: item.typeName };
        });
      });
    },
    // 获取平台业务管理-订单状态列表
  },
};
</script>
<style scoped lang="scss">
.mutil-select {
  ::v-deep .el-select__tags-text {
    max-width: 80px;
  }
}
</style>
